import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import BoilerDetail from '../../components/hot_water_system/BoilerDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { editBoiler } from '../../redux/boiler/boiler_actions';

class BoilerEditModal extends React.Component {
  constructor(props) {
    super(props);
    this.boilerDetail = undefined;
    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const newBoiler = this.boilerDetail.getWrappedInstance().getWrappedInstance().getBoilerData();
    this.props.editBoiler({ ...newBoiler, id: this.props.boiler.id });
  }

  render() {
    const { isEditing, errorMessage, boiler, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('edit boiler')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BoilerDetail
            boiler={boiler}
            ref={ref => (this.boilerDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isEditing && !this.props.isEdited && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="hot-water-boiler-submit-edit"
            disabled={!isSubmittable || isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const boilerState = state.hotWaterSystem.boiler;
  return {
    errorMessage: boilerState.errorMessage,
    isEditing: boilerState.isEditing,
  };
};

const mapDispatchToProps = dispatch => ({
  editBoiler: boiler =>
    defaultRejectHandler(
      dispatch(
        editBoiler(
          boiler.id,
          boiler.name,
          boiler.efficiency,
          boiler.type_id,
          boiler.description,
          boiler.image,
          boiler.cfp_value,
          boiler.cfp_unit,
        ),
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(BoilerEditModal),
);



// WEBPACK FOOTER //
// ./src/modal/boiler/BoilerEditModal.js